import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { fetchSettings } from "../lib/api";

const calc = (target) => {
  const diff = Math.max(0, new Date(target).getTime() - Date.now());
  const d = Math.floor(diff / 86400000);
  const h = Math.floor((diff % 86400000) / 3600000);
  const m = Math.floor((diff % 3600000) / 60000);
  const s = Math.floor((diff % 60000) / 1000);
  return { d, h, m, s, done: diff === 0 };
};

export const CountdownBanner = () => {
  const [settings, setSettings] = useState(null);
  const [t, setT] = useState(null);

  useEffect(() => {
    fetchSettings().then(setSettings).catch(() => {});
  }, []);

  useEffect(() => {
    if (!settings?.launch_enabled || !settings?.launch_date) return;
    const tick = () => setT(calc(settings.launch_date));
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, [settings]);

  if (!settings?.launch_enabled || !settings?.launch_date || !t || t.done) return null;
  // While a Live Author Moment is active, yield the top slot to the LiveBanner.
  if (settings?.live?.active) return null;

  const Unit = ({ v, l }) => (
    <div className="flex flex-col items-center px-2 md:px-3">
      <span className="font-display text-lg md:text-2xl text-gold leading-none tabular-nums">{String(v).padStart(2, "0")}</span>
      <span className="text-[9px] uppercase tracking-widest text-cream/60 mt-1">{l}</span>
    </div>
  );

  return (
    <div className="fixed top-20 left-0 right-0 z-40 bg-emerald-deep border-b border-gold/30" data-testid="countdown-banner">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 h-14 md:h-16 flex items-center justify-center md:justify-between gap-4">
        <p className="hidden md:block eyebrow text-gold">The Love Genome™ launches soon</p>
        <div className="flex items-center gap-1 md:gap-2">
          <Unit v={t.d} l="Days" />
          <span className="text-gold/40">:</span>
          <Unit v={t.h} l="Hrs" />
          <span className="text-gold/40">:</span>
          <Unit v={t.m} l="Min" />
          <span className="text-gold/40">:</span>
          <Unit v={t.s} l="Sec" />
        </div>
        <Link to="/store" className="hidden md:inline-flex btn-gold !py-2 !px-5 text-xs" data-testid="countdown-cta">
          Pre-order
        </Link>
      </div>
    </div>
  );
};

export default CountdownBanner;
